import type { MailboxInfo } from 'owa-client-types';
import type { PickerType } from '../store/schema/CopilotAccountPickerStoreSchema';
import { action } from 'satcheljs';

export interface ON_COPILOT_ACCOUNT_PICKER_SWITCHEDActionMessage {
    account: MailboxInfo;
    targetWindow: Window;
    pickerOrigin: PickerType;
}

export const onCopilotAccountPickerSwitched: (
    account: MailboxInfo,
    targetWindow: Window,
    pickerOrigin: PickerType
) => ON_COPILOT_ACCOUNT_PICKER_SWITCHEDActionMessage = action(
    'ON_COPILOT_ACCOUNT_PICKER_SWITCHED',
    (
        account: MailboxInfo,
        targetWindow: Window,
        pickerOrigin: PickerType
    ): ON_COPILOT_ACCOUNT_PICKER_SWITCHEDActionMessage => ({
        account,
        targetWindow,
        pickerOrigin,
    })
);
